import { render, staticRenderFns } from "./BaseLoadingSpinner.vue?vue&type=template&id=bfb1d3e6"
import script from "./BaseLoadingSpinner.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseLoadingSpinner.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports